import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';;
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { DirectiveModule } from '../directive/directive.module';
import { ButtonComponent } from './simple-button/button.component';
import { CheckboxComponent } from './simple-checkbox/checkbox.component';
import { DateComponent } from './simple-date/date.component';
import { DynamicFieldDirective } from './simple-dynamic-field/dynamic-field.directive';
import { SimpleDynamicFormComponent } from './simple-dynamic-form/simple-dynamic-form.component';
import { FileUploadComponent } from './simple-file-upload/file-upload.component';

import { PriceComponent } from './simple-price/price.component';
import { RadiobuttonComponent } from './simple-radiobutton/radiobutton.component';
import { SelectComponent } from './simple-select/select.component';
import { InputLeadComponent } from './simple-input/input-lead/input-lead.component';
import { CommonImagesModule } from 'src/app/pages/common-images/common-images.module';


@NgModule({
  declarations: [
    ButtonComponent,
    SelectComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    DynamicFieldDirective,
    SimpleDynamicFormComponent,
    PriceComponent,
    FileUploadComponent,
    InputLeadComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    DirectiveModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    ReactiveFormsModule,
    FormsModule,
    CustomFlexLayoutModule,
    CommonFileUploadModule,
    CommonImagesModule

  ],
  exports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    SimpleDynamicFormComponent
  ]
})
export class SimpleDynamicComponentModule { }
